import { render, staticRenderFns } from "./customsManual.vue?vue&type=template&id=d0725204&scoped=true&"
import script from "./customsManual.vue?vue&type=script&lang=js&"
export * from "./customsManual.vue?vue&type=script&lang=js&"
import style0 from "./customsManual.vue?vue&type=style&index=0&id=d0725204&scoped=true&lang=scss&"
import style1 from "./customsManual.vue?vue&type=style&index=1&lang=css&"
import style2 from "./customsManual.vue?vue&type=style&index=2&id=d0725204&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0725204",
  null
  
)

export default component.exports